import { Box } from '@mui/material';

type ModalFooterProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  hideTopBorder?: boolean;
};

const VnModalFooter = ({ left, right, hideTopBorder = false }: ModalFooterProps) => {
  if (!left && !right) return null;

  return (
    <Box sx={{ px: '16px', pt: '8px' }}>
      <Box sx={{ borderTop: hideTopBorder ? 'none' : '1px solid #E6E8EC', pt: '16px', pb: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box>{left}</Box>

          <Box sx={{ display: 'flex', gap: 2 }}>{right}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VnModalFooter;
